import { Module } from "vuex";
import { IMyIssuanceState } from "@/core/interfaces/myIssuance.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const myIssuanceModule: Module<IMyIssuanceState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default myIssuanceModule;
